import { Box, Button, Card, Grid } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useSearchParams } from 'react-router-dom';
import { firstBy } from 'thenby';
import { useAppContext } from '../../../../libs/app-core/AppContext';
import { Toast } from '../../../../libs/app-core/Toast';
import { useGridApiRef } from '../../../../libs/data-grid-view/useGridApiRef';
import { linear_content_style, linear_h, linear_item, linear_v } from '../../../../libs/linear-layout/LinearLayout';
import Title from '../../../../libs/rhf-mui/ui/Title';
import AppMenuButton from '../../../components/AppMenuButton';
import { Member } from '../../../dao/Member';
import { useMemberList } from '../../../dao/MemberDAO';
import { useProject } from '../../../dao/ProjectDAO';
import { useUniFuncList } from '../../../dao/UniFuncDAO';
import { R } from '../../../R';
import UcUniFuncPills from './UcUniFuncPills';

type Props = {}

const FrmDevProjectEditor = (props: Props) => {

  const [searchParams] = useSearchParams();// UrlQueryParams
  const project_guid = searchParams.get("project") ?? "";
  //---------------------------------------------------------------

  const { _UniFuncList } = useUniFuncList();

  const columns: GridColDef[] = [
    { field: 'serno', headerName: 'ID', width: 90 },
    { field: 'member_code', headerName: '個案編號', width: 150 },
    { field: 'member_name', headerName: '個案名稱', width: 150 },
    {
      field: 'common_uni_func_guids', headerName: '特作問卷', width: 960,
      renderCell: (params: GridRenderCellParams<string>) => {
        const member: Member = params.row;
        return <UcUniFuncPills ctx={ctx} UniFuncListCache={_UniFuncList}
          member={member} is_spwk={true}// 特作問卷
        />
      }
    },
    {
      field: 'spwk_uni_func_guids', headerName: '一般問卷', width: 300,
      renderCell: (params: GridRenderCellParams<string>) => {
        const member: Member = params.row;
        return <UcUniFuncPills ctx={ctx} UniFuncListCache={_UniFuncList}
          member={member} is_spwk={false}// 一般問卷
        />
      }
    },
  ];



  const grid_api = useGridApiRef(columns);

  const ctx = useAppContext();

  const { _Project } = useProject(project_guid);
  const { _MemberList } = useMemberList(project_guid);

  return (
    <Box style={linear_content_style} bgcolor={R.color.paper}>
      <Grid {...linear_v} >
        <Grid {...linear_item}  >
          {render_ProjectInfo()}
        </Grid>
        <Grid {...linear_item}  >
          {render_ActionBar()}
        </Grid>
        <Grid {...linear_item} flex={1} p={1} >
          {render_DataGrid()}
        </Grid>
      </Grid>
    </Box>
  )

  function render_ProjectInfo() {
    return (
      <Grid  {...linear_v} >
        <Grid {...linear_item} >
          <Grid  {...linear_h} alignItems='center' p={1}>
            {<AppMenuButton label={<Title color='error'>
              {[`[DEV] [${_Project?.project_code}] ${_Project?.project_name}`]}
            </Title>} />}
          </Grid>
        </Grid>
        <Grid {...linear_item} >
          <Card sx={{ p: 2, m: 1 }}>
            <Title variant='body1'> TODO 更多場次資訊 ...<br /> </Title>
          </Card>
        </Grid>
      </Grid>
    );
  }

  function render_ActionBar() {
    return (<Grid  {...linear_h} alignItems='center' p={1}>
      <Title variant='subtitle2'>個案列表</Title>
      <Grid {...linear_item} flex={1}>
        {/* blank full width */}
      </Grid>
      <Grid {...linear_item}>
        <Button variant='contained' onClick={() => { btn匯出_Click() }}>匯出</Button>
      </Grid>
      <Grid {...linear_item}>
        <Title>...</Title>
      </Grid>
    </Grid>);
  }

  function render_DataGrid() {
    return (
      <Card sx={{ height: '100%', width: '100%' }}>
        <DataGrid sx={{ width: '100%', backgroundColor: 'white', padding: '12px', border: 'none' }}

          checkboxSelection={true}
          disableSelectionOnClick={true}

          getRowId={(data) => { return data.guid }}
          rows={_MemberList}
          columns={grid_api.columns}
          pageSize={100}
          rowsPerPageOptions={[100]}
          onRowDoubleClick={(params) => {
            Toast.Show(ctx, "個案: " + params.id);
          }}
        />
      </Card>
    );
  }



  function btn匯出_Click() {
    const sel_rows = grid_api.apiRef.current?.getSelectedRows();

    let member_list: Member[] = [];

    sel_rows?.forEach(function (value, key) {

      let member = value as Member;
      member_list.push(member);
    });

    member_list = member_list.sort(firstBy("member_name").thenBy("serno"));
  }


}






export default FrmDevProjectEditor